import { render, staticRenderFns } from "./PriceCalculations.vue?vue&type=template&id=3e36edd8&scoped=true&"
import script from "./PriceCalculations.vue?vue&type=script&lang=js&"
export * from "./PriceCalculations.vue?vue&type=script&lang=js&"
import style0 from "./PriceCalculations.vue?vue&type=style&index=0&id=3e36edd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e36edd8",
  null
  
)

export default component.exports